<template>
  <div>
    <PageTitle
      title="Sales Return Details"
      :printvisible="true"
      :backBtn="true"
      @openPrintmethod="GotoPrintDetails"
    />
    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-sale</v-icon
                  ><span class="ml-3"> Sales Return Details</span></v-card-title
                >
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row class="pt-0">
                        <v-col
                          cols="12"
                          sm="12"
                          md="4"
                          lg="4"
                          class="pr-5pt-1.5 pb-1 reference_number"
                        >
                          <v-icon>mdi-sale</v-icon>
                          {{
                            sale.reference_number
                              ? sale.reference_number
                              : '----'
                          }}
                        </v-col>

                        <v-col cols="12" sm="12" md="4" lg="4"
                          ><span class="statustext pr-5">Payment Status</span
                          ><v-chip
                            label
                            text-color="white"
                            style="
                              font-variant-caps: all-small-caps;
                              font-weight: bold;
                            "
                            :color="getPurchaseOrderStatusColor(sale.status)"
                            dark
                            >{{ sale.status ? sale.status : '----' }}</v-chip
                          ></v-col
                        >
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Shop </v-row>
                          <v-row>
                            {{ sale.shop ? sale.shop.name : '----' }}
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Biller </v-row>
                          <v-row>
                            {{ sale.biller ? sale.biller.first_name : '----' }}
                          </v-row>
                        </v-col>

                        <v-col cols="1" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Sale Date </v-row>
                          <v-row>
                            <v-icon small>mdi-calendar</v-icon>
                            {{ sale.date | formatDate }}
                          </v-row>
                        </v-col>

                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Customer </v-row>
                          <v-row>
                            {{ sale.customer ? sale.customer.name : '----' }}
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Sale Reference </v-row>
                          <v-row>
                            <v-chip
                              color="blue"
                              class="pa-0 pulse"
                              x-small
                              outlined
                              @click="
                                $router.push('/sales/view/' + sale.sale.id)
                              "
                              >{{
                                sale.sale ? sale.sale.reference_number : '----'
                              }}</v-chip
                            >
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small
                    >mdi-checkbox-marked-circle-outline</v-icon
                  ><span class="ml-3"> Sales Return Items</span></v-card-title
                >
                <v-container fluid class="container saledetailscard">
                  <v-row
                    v-for="saleReturnItem in sale.saleReturnItem"
                    :key="saleReturnItem"
                    class="saletiltle"
                  >
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Item </v-row>
                          <v-row>
                            {{
                              saleReturnItem.product
                                ? saleReturnItem.product.name
                                : '----'
                            }}
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Unit </v-row
                          ><v-row>{{
                            saleReturnItem.unit
                              ? saleReturnItem.unit.name
                              : '----'
                          }}</v-row>
                          <v-row class="subtextlable"> Batch </v-row
                          ><v-row>{{
                            saleReturnItem.batch
                              ? saleReturnItem.batch.batch
                              : '----'
                          }}</v-row>
                        </v-col>

                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Quantity </v-row>
                          <v-row>
                            {{
                              saleReturnItem.quantity
                                ? saleReturnItem.quantity
                                : '----'
                            }}
                          </v-row>
                        </v-col>

                        <v-col cols="1" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="shoptext pr-2 pt-0"
                        >
                          <v-row class="pt-0">
                            <v-col
                              cols="12"
                              sm="12"
                              md="5"
                              lg="5"
                              class="subtextlable"
                            >
                              Unit Rate
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="7"
                              lg="7"
                              style="text-align: right"
                            >
                              LKR
                              {{ saleReturnItem.amount | formatCurrency }}
                            </v-col>
                          </v-row>
                          <v-row class="pt-0">
                            <v-col
                              cols="12"
                              sm="12"
                              md="5"
                              lg="5"
                              class="subtextlable"
                            >
                              Unit Value
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="7"
                              lg="7"
                              style="text-align: right"
                            >
                              LKR
                              {{
                                (saleReturnItem.amount *
                                  saleReturnItem.quantity)
                                  | formatCurrency
                              }}
                            </v-col>
                          </v-row>
                          <v-row class="pt-0">
                            <v-col
                              cols="12"
                              sm="12"
                              md="5"
                              lg="5"
                              class="subtextlable"
                            >
                              Return Charges
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="7"
                              lg="7"
                              style="text-align: right"
                            >
                              LKR
                              {{
                                saleReturnItem.return_charge | formatCurrency
                              }}
                            </v-col>
                          </v-row>

                          <v-row class="pt-0">
                            <v-col
                              cols="12"
                              sm="12"
                              md="5"
                              lg="5"
                              class="subtextlable"
                            >
                              Sub Total
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="7"
                              lg="7"
                              style="text-align: right"
                            >
                              LKR
                              {{
                                (saleReturnItem.amount -
                                  saleReturnItem.return_charge)
                                  | formatCurrency
                              }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-col>
                    <v-row
                      class="blue darken-1 white--text font-weight-black title"
                      style="margin: -29px"
                    >
                      <v-col
                        cols="5"
                        sm="12"
                        md="5"
                        lg="5"
                        class="saletiltle"
                        style="font-weight: bold"
                      >
                        Net Amount
                      </v-col>
                      <v-col
                        cols="7"
                        sm="12"
                        md="7"
                        lg="7"
                        class="saletiltle"
                        style="text-align: right; font-weight: bold"
                      >
                        LKR {{ sale.total | formatCurrency }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-credit-card-multiple</v-icon><span class="ml-3"> Type Of
                  Payments Summary</span>
                </v-card-title>
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row
                        class="pt-0"
                        v-for="payement in sale.payments"
                        :key="payement"
                      >
                        <v-col
                          cols="2"
                          sm="12"
                          md="2"
                          lg="2"
                          class="pr-5pt-1.5 pb-1 shoptext"
                        >
                          <v-icon small>mdi-calendar</v-icon>
                          {{ payement.date_time | formatDate }}
                        </v-col>
                        <v-col
                          cols="2"
                          sm="12"
                          md="2"
                          lg="2"
                          class="pr-5pt-1.5 pb-1 shoptext"
                        >
                          LKR {{ payement.amount | formatCurrency }}
                        </v-col>

                        <v-col
                          cols="4"
                          sm="12"
                          md="4"
                          lg="4"
                          style="text-align: right"
                          ><span class="statustext pr-5">Payment Status</span
                          ><v-chip
                            label
                            text-color="white"
                            style="
                              font-variant-caps: all-small-caps;
                              font-weight: bold;
                            "
                            :color="GetChequeStatusColor(payement.status)"
                            dark
                            >{{ payement.status }}</v-chip
                          ></v-col
                        >

                        <v-col
                          cols="3"
                          sm="12"
                          md="3"
                          lg="3"
                          style="text-align: right"
                        >
                          <span class="statustext pr-5">Payment Type</span>
                          <v-chip
                            label
                            style="
                              background-color: #c11e65;
                              color: white;
                              font-variant-caps: all-small-caps;
                              font-weight: bold;
                            "
                          >
                            {{
                              payement.payment_type
                                ? payement.payment_type
                                : "----"
                            }}
                          </v-chip></v-col
                        >
                        <v-col
                          cols="1"
                          sm="12"
                          md="1"
                          lg="1"
                          class="pr-3 pt-1.5 pb-2  shoptext"
                        >
                         <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                           v-bind="attrs"
                          v-on="on"
                            v-if="
                              !(
                                payement.status != 'Pending' &&
                                payement.payment_type == 'Cheque'
                              )
                            "
                            small
                            class="mr-2 pb-2 mt-1"
                            color="primary"
                            @click.stop="EditPayment(payement)"
                          >
                            mdi-pencil
                          </v-icon>
                        </template>
                         <span>Edit</span>
                           </v-tooltip>
                           <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                          <v-icon
                          v-bind="attrs"
                          v-on="on"
                            small
                            @click="ViewPayment(payement)"
                            color="green"
                            class="mr-2 pb-2 mt-1"
                          >
                            mdi-eye
                          </v-icon>
                          </template>
                           <span>View</span>
                           </v-tooltip>
                        </v-col>
                       
                    
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>

              <SalesPaymentModal
                ref="PaymentModal"
                @conform="refreshPayments"
                :visible="showScheduleForm"
                :debitAccount="debitAccount"
                :creditAccounts="debitAccount"
                :payment="payment"
                :salesId="sale.id"
                :customerId="sale.customer"
              />

              <SalesPaymentEditModal
                ref="PaymentEditModel"
                @conform="refreshPayments"
                :visible="showEditForm"
                :debitAccount="debitAccount"
                :salesId="sale.id"
                :payment="payment"
                :creditAccounts="supplierCreditAccounts"
              />
            </v-col>
          </v-row> -->
        </v-col>

        <!-- <v-col>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-cash-multiple</v-icon> <span class="ml-3">Payment
                  Summary</span>
                </v-card-title>
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row class="pt-0">
                        <v-col
                          cols="5"
                          sm="12"
                          md="5"
                          lg="5"
                          class="paymenttext"
                        >
                          Due
                        </v-col>
                        <v-col
                          cols="7"
                          sm="12"
                          md="7"
                          lg="7"
                          class="saletiltle"
                          style="text-align: right"
                        >
                          LKR
                          {{
                            (sale.grand_total - sale.paid_amount)
                              | formatCurrency
                          }}
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-row class="pt-0">
                        <v-col
                          cols="5"
                          sm="12"
                          md="5"
                          lg="5"
                          class="paymenttext"
                        >
                          Total
                        </v-col>
                        <v-col
                          cols="7"
                          sm="12"
                          md="7"
                          lg="7"
                          class="saletiltle"
                          style="text-align: right"
                        >
                          LKR {{ sale.total | formatCurrency }}
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-row class="pt-0">
                        <v-col
                          cols="5"
                          sm="12"
                          md="5"
                          lg="5"
                          class="paymenttext"
                        >
                          Discount
                        </v-col>
                        <v-col
                          cols="7"
                          sm="12"
                          md="7"
                          lg="7"
                          class="saletiltle"
                          style="text-align: right"
                        >
                          LKR
                          {{ sale.discount_amount ? sale.discount_amount : 0 }}
                        </v-col>
                      </v-row>
                      <v-row
                        class="
                          blue
                          darken-1
                          white--text
                          font-weight-black
                          title
                        "
                      >
                        <v-col
                          cols="5"
                          sm="12"
                          md="5"
                          lg="5"
                          class="saletiltle"
                          style="font-weight: bold"
                        >
                          Grand Total
                        </v-col>
                        <v-col
                          cols="7"
                          sm="12"
                          md="7"
                          lg="7"
                          class="saletiltle"
                          style="text-align: right; font-weight: bold"
                        >
                          LKR {{ sale.grand_total | formatCurrency }}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card class="lighten-12">
                    <v-card-title class="v-card__title saletiltle"
                      ><v-icon color="blue" small>mdi-cash</v-icon><span class="ml-3"> Payments</span>
                    </v-card-title>
                    <v-container fluid class="container saledetailscard">
                      <v-row>
                        <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                          <v-row class="pt-0">
                            <v-col
                              cols="5"
                              sm="12"
                              md="5"
                              lg="5"
                              class="paymenttext"
                            >
                              Total Amount
                            </v-col>
                            <v-col
                              cols="7"
                              sm="12"
                              md="7"
                              lg="7"
                              class="saletiltle"
                              style="text-align: right"
                            >
                              LKR
                              {{ sale.grand_total | formatCurrency }}
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                          <v-row class="pt-0">
                            <v-col
                              cols="5"
                              sm="12"
                              md="5"
                              lg="5"
                              class="paymenttext"
                            >
                              Balance
                            </v-col>
                            <v-col
                              cols="7"
                              sm="12"
                              md="7"
                              lg="7"
                              class="saletiltle"
                              style="text-align: right"
                            >
                              LKR
                              {{
                                (sale.grand_total - sale.paid_amount)
                                  | formatCurrency
                              }}
                            </v-col>
                          </v-row>

                          <v-row
                            class="
                              blue
                              darken-1
                              white--text
                              font-weight-black
                              title
                            "
                            v-if="sale.grand_total - sale.paid_amount > 0"
                            @click="OpenPayment()"
                          >
                            <v-col
                              cols="7"
                              sm="12"
                              md="7"
                              lg="7"
                              class="saletiltle"
                              style="text-align: right; font-weight: bold"
                              rounded
                              color="primary"
                              dark
                            >
                              PAY
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="sale.saleServices && sale.saleServices.length > 0">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-card class="lighten-12">
                    <v-card-title class="v-card__title saletiltle"
                      ><v-icon color="blue" small>mdi-car-wash</v-icon><span class="ml-3"> Sales
                      Services</span>
                    </v-card-title>
                    <v-container fluid class="container saledetailscard">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="pt-0"
                          v-for="service in sale.saleServices"
                          :key="service"
                        >
                          <v-row>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: left"
                              ><span class="statustext">Code</span>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: right"
                              >{{ service.service.code }}
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: left"
                              ><span class="statustext">Name</span>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: right"
                              >{{ service.service.name }}
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: left"
                              ><span class="statustext">Service Amount</span>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: right"
                              >LKR {{ service.service.amount }}
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: left"
                              ><span class="statustext">Sale Amount</span>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: right"
                              >LKR {{ service.amount }}
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: left"
                              ><span class="statustext">Discount</span>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="12"
                              md="6"
                              lg="6"
                              style="text-align: right"
                              >LKR {{ service.bargain_discount }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col> -->
      </v-row>

      <change-status
        :visible="visibleChangeStatusModal"
        :statuses="saleStatuses"
        :selectedStatus="sale.status"
        @onChangeStatus="onChangeStatus"
        @close="onCloseChangeStatus"
      ></change-status>
      <salebill
        ref="CallingBill"
        :ProductDatas="sale.saleItems"
        :PaymentDetails="sale.payments"
        :SaleDetails="sale"
        @closePreview="closePreview"
        v-show="false"
        :visible="salesBillVisible"
      />
    </v-container>
  </div>
</template>

<script>
import salebill from '@/components/shared/SalesBill.vue';
import FileUpload from '@/components/base/FileUpload';
import jsPDF from 'jspdf';
import SalesPaymentModal from '../shared/modals/SalesPaymentModal';
import SalesPaymentEditModal from '../shared/modals/SalesPaymentEditModal';
import VueDocPreview from 'vue-doc-preview';
import 'jspdf-autotable';
import { Payment } from '@/models/Payment';
import { SaleViewModel } from '../../models/View Models/SaleViewModel';
import ChangeStatus from '@/components/shared/ChangeStatus';
import axios from 'axios';

export default {
  data: () => ({
    supplierCreditAccounts: '',
    showEditForm: '',
    showScheduleForm: '',
    sale: new SaleViewModel(),
    isLoading: false,
    salesBillVisible: false,
    salesItemsTotal: 0,
    debitAccount: null,
    payment: [],
    discountItemTotal: 0,
    saleStatuses: [
      { requiredNote: true, status: 'Completed' },
      { requiredNote: true, status: 'Pending' },
      { requiredNote: true, status: 'Suspended' },
      { requiredNote: true, status: 'Closed' },
      { requiredNote: true, status: 'Canceled' },
    ],
    paymentHeaders: [
      { text: 'Date', value: 'date_time' },
      { text: 'Amount', value: 'amount' },
      { text: 'Payment Type', value: 'payment_type' },
      { text: 'status', value: 'status', align: 'center' },
      { text: '', value: 'action' },
    ],
    headers: [
      {
        text: 'Name',
        value: 'product.name',
        show: true,
        disabled: true,
        align: 'center',
        width: '14%',
      },
      {
        text: 'Unit',
        value: 'unit.name',
        show: true,
        disabled: true,
        align: 'center',
        width: '14%',
      },
      {
        text: 'Batch',
        value: 'batch.batch',
        show: true,
        disabled: false,
        align: 'center',
        width: '14%',
      },
      {
        text: 'Unit Price',
        value: 'amount',
        show: true,
        disabled: true,
        align: 'center',
        width: '14%',
      },
      {
        text: 'Quantity',
        value: 'quantity',
        show: true,
        disabled: false,
        align: 'center',
        width: '14%',
      },
      {
        text: 'Discount',
        value: 'discount_amount',
        show: true,
        disabled: false,
        align: 'center',
        width: '14%',
      },

      {
        text: 'Subtotal',
        value: 'subtotal',
        show: true,
        disabled: false,
        align: 'center',
        width: '14%',
      },
    ],
    Serviceheaders: [
      {
        text: 'Name',
        value: 'service.name',
        show: true,
        disabled: true,
        align: 'center',
      },

      {
        text: ' Price',
        value: 'amount',
        show: true,
        disabled: true,
        align: 'center',
      },

      {
        text: 'Discount',
        value: 'bargain_discount',
        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    visibleChangeStatusModal: false,
  }),
  methods: {
    onChangeStatus(value) {
      value.id = this.$route.params.id;
      this.$store
        .dispatch('sales/ChangeStatus', value)
        .then((res) => {
          this.getSale();
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    onClickChangeStatus(value) {
      this.visibleChangeStatusModal = true;
    },
    onCloseChangeStatus() {
      this.visibleChangeStatusModal = false;
    },
    closePreview() {
      this.salesBillVisible = false;
    },
    GotoPrintDetails() {
      setTimeout(() => {
        this.salesBillVisible = true;
      }, 100);
    },
    GetChequeStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        case 'Return':
          return '#973a5a';
          break;
        default:
          break;
      }
    },
    getPurchaseOrderStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Partially Paid':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        default:
          break;
      }
    },
    refreshPayments() {
      this.getSale();
    },
    sumField() {
      // sum data in give key (property)

      this.sale.saleItems.map((a) => {
        this.salesItemsTotal += a.amount * a.quantity;
      });
    },
    sumDiscountField() {
      // sum data in give key (property)

      this.sale.saleItems.map((a) => {
        this.discountItemTotal += a.bargain_discount * a.quantity;
      });
    },
    print() {
      this.$htmlToPaper('qr-code');
    },
    OpenPayment() {
      this.payment = new Payment();
      this.$refs.PaymentModal.openModal();
    },
    ViewPayment(item) {
      this.$router.push(`/payment/${item.id}`);
    },
    EditPayment(item) {
      this.payment.account_id = this.sale.account_id;
      this.payment = _.cloneDeep(item);
      if (this.payment.cheque) {
        this.payment.cheque_bank = item.cheque.cheque_bank;
        this.payment.cheque_date = item.cheque.cheque_date;
        this.payment.cheque_no = item.cheque.cheque_no;
        this.payment.cheque_type = item.cheque.cheque_type;
      }

      this.$refs.PaymentEditModel.openModal();
    },
    getSale() {
      let id = this.$route.params.id;
      this.$store
        .dispatch('sales/GetSaleReturn', id)
        .then((res) => {
          this.sale = res.data;

          this.sumField();
          this.sumDiscountField();
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
  },
  GetDebitAccounts() {
    this.$store
      .dispatch('purchase/GetDebitAccounts', { accountType: 'Purchase' })
      .then((res) => {
        this.debitAccount = res.data.data.map((u) => {
          return new AccountViewModel(u);
        });
        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
        this.messages = err.data.title;
      });
  },
  created() {
    this.getSale();
  },
  components: {
    FileUpload,
    VueDocPreview,
    SalesPaymentModal,
    SalesPaymentEditModal,
    ChangeStatus,
    salebill,
  },
  computed: {
    printQr() {
      return {
        id: 'qr-code',
        popTitle: this.sale.name,
      };
    },
  },
};
</script>

<style scoped>
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}

.rowspace {
  margin-top: -25px;
  margin-bottom: -40px;
}

.pr-100 {
  padding-right: 30px;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.borderline {
  border: 1px dashed #4e879f;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.pulse {
  background: #2c44cc;

  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 0 rgba(6, 173, 233, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(102, 15, 15, 0.4);
    box-shadow: 0 0 0 0 rgba(179, 52, 30, 0);
  }
}
.paymenttext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 12px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
</style>
